import { z } from "zod";
import { ChoiceOptionsSchema, FieldBaseSchema, defineControl } from "./field.js";
// A radio group shows every choice at once, so there is nothing collapsed to
// prompt for: options, but no placeholder. Two to start with, named and valued
// for their place, so the group has something to show before an administrator
// has named anything.
export const radioGroup = defineControl({
    key: "radioGroup",
    label: "Radio group",
    schema: FieldBaseSchema.extend({
        control: z.literal("radioGroup"),
        ...ChoiceOptionsSchema.shape,
    }),
    answer: z.string(),
    isClearable: true,
    empty: {
        required: false,
        options: [
            { label: "Option 1", value: "option-1" },
            { label: "Option 2", value: "option-2" },
        ],
    },
});
